class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", "false");
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector("header");
    this.nav = document.querySelector("nav.header__inline-menu");
    const detailsCollection = this.nav.getElementsByTagName("details");
    const summaryCollection = this.nav.getElementsByTagName("summary");
    // eslint-disable-next-line no-unused-vars
    for (const [key, summary] of Object.entries(summaryCollection)) {
      summary.onclick = (mouseEvent) => {
        mouseEvent.preventDefault();

        if (mouseEvent.target.dataset.linkUrl) {
          window.location.href = mouseEvent.target.dataset.linkUrl;
        }
      };
    }

    // eslint-disable-next-line no-unused-vars
    for (const [key, details] of Object.entries(detailsCollection)) {
      details.onmouseenter = (mouseEvent) => {
        const target = this.getDetails(mouseEvent);
        if (typeof target !== "undefined") {
          target.open = true;
        }
      };
      details.onmouseleave = (mouseEvent) => {
        const target = this.getDetails(mouseEvent);
        if (typeof target !== "undefined") {
          target.open = false;
        }
      };
    }
  }

  getDetails(mouseEvent) {
    let target = mouseEvent.target;
    if (target.tagName === "SUMMARY") {
      target = target.parentNode;
    }
    if (target.tagName !== "DETAILS") {
      return undefined;
    }
    return target;
  }

  onToggle() {
    if (this.header) {
      if (this.mainDetailsToggle?.hasAttribute("open")) {
        this.header.setAttribute("open", "true");
      } else {
        this.header.removeAttribute("open");
      }
    }
    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    if (this.header)
      document.documentElement.style.setProperty(
        "--header-bottom-position-desktop",
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
  }
}

customElements.define("header-menu", HeaderMenu);
